import { profileDefault } from './profileDefault';

export function resolveCaixaProfile() {
    return profileDefault;
}

export function sanitizeCaixaByProfile({ raw, profile }) {
    const p = profile || profileDefault;

    const safeProfile = {
        ...p,
        tabs: {
            caixa: { enabled: true, ...(p?.tabs?.caixa || {}) },
            lancamentos: { enabled: true, ...(p?.tabs?.lancamentos || {}) },
        },
    };

    return raw ?? safeProfile;
}
